import React, { useEffect, useState } from "react";
import { Input, Space, Form, Button, message, Modal, notification } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { GrUpload } from "react-icons/gr";


import {
  Image,
  Select,
  TimePicker,
  Upload,
} from "antd";
import WebContactRequest from "./webContactRequest";
const initialFilter = { page: 1, limit: 10 };

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });


function WebContactCreate() {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const [websiteFileList, setWebsiteFileList] = useState([]);
  const [mobileFileList, setMobileFileList] = useState([]);
  const navigate = useNavigate()
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [videoList, setVideoList] = useState([]);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filter, setFilter] = useState(initialFilter);
  const [pathType, setPathType] = useState(''); // Store selected pathType
  const [pathIdOptions, setPathIdOptions] = useState([]); // Store fetched pathId options
  const [options, setOptions] = useState([]); // Options for select

  const { Option } = Select;

  const onFinish = (values) => {
    console.log(values)

    setLoading(true);
    const allFormData = { ...values };
    console.log("allFormData", allFormData)
    WebContactRequest.createContact(allFormData)
      .then((res) => {
        console.log("API Response:", res);
        if (res.status === 201) {
          notification.success({
            message: "Contact Details added successfully",
          });
          navigate(-1);
        } else {
          notification.error({
            message: "Something went wrong",
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to add contact details",
        });
        console.error("API Error:", e);
      });

  };



  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };



  return (
    <div>
      <section>
        <div className="Create-Category">
          <Form.Item className=" submit-btn">
            <Space>
              <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Create Contact Details</h3>


          <Form
            layout="vertical"
            className="subscription-form"
            form={form}
            onFinish={onFinish}
          >
            <div className="subscription">
              <Form.Item
                label="Page Key"
                name="pageKey"
                className="subscription-plan"
                rules={[

                  {
                    pattern: /^[a-z0-9-]+$/,
                    message: "pageKey can contain only lowercase letters, numbers, and hyphens",
                  },
                ]}
              >
                <Input size="large" placeholder="where you want to place this contact details" />
              </Form.Item>

              <Form.Item
                label="Status"
                name="status"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select status" },
                ]}
              >
                <Select
                  placeholder="Select status"
                  // style={{
                  //   marginTop: "0.5rem",

                  //   width: "99%",
                  // }}
                  onChange={handleChange}
                  options={[
                    {
                      value: "0",
                      label: "Inactive",
                    },
                    {
                      value: "1",
                      label: "Active",
                    },

                  ]}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                label="Location"
                name="location"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter location" },
                  {
                    pattern: /^[A-Za-z0-9\s,.'-]+$/,
                    message: "Location can only contain letters, numbers, spaces, commas, periods, hyphens and apostrophes!",
                  },
                  {
                    min: 2,
                    message: "Location must be at least 2 characters long",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter location" />
              </Form.Item>

              <Form.Item
                label="Email "
                name="email"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter email" },
                  {
                    type: "email",
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input size="large" placeholder="example@email.com" />
              </Form.Item>
            </div>


            <div className="subscription">

              <Form.Item
                label="Mobile Number"
                name="mobile"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter mobile number",
                  },
                  {
                    pattern: /^[6-9]\d{9}$/,
                    message: "Please enter a valid 10-digit mobile number",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter mobile"
                  maxLength={10}
                />
              </Form.Item>
            </div>






            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save & Proceed
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>

          </Form>
        </div>
      </section>
    </div>
  )
}

export default WebContactCreate
